var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "left_tree" },
      [
        _c(
          "vxe-button",
          {
            staticStyle: { margin: "0 0 10px 0" },
            on: { click: _vm.addGroup },
          },
          [_vm._v("新增分组")]
        ),
        _c(
          "vxe-button",
          {
            staticStyle: { margin: "0 7px 10px" },
            on: { click: _vm.updateGroup },
          },
          [_vm._v("修改分组")]
        ),
        _c(
          "vxe-button",
          {
            staticStyle: { margin: "0 0 10px 0" },
            on: { click: _vm.deleteGroup },
          },
          [_vm._v("删除分组")]
        ),
        _c(
          "a-tree",
          {
            attrs: {
              "show-icon": true,
              checkStrictly: true,
              defaultExpandAll: false,
              defaultExpandParent: true,
              expandedKeys: _vm.defaultExpandedKeys,
              "tree-data": _vm.tagList,
              selectedKeys: _vm.selectedKeys,
              replaceFields: {
                children: "children",
                title: "groupName",
                key: "groupId",
                value: "groupId",
              },
            },
            on: {
              "update:expandedKeys": function ($event) {
                _vm.defaultExpandedKeys = $event
              },
              "update:expanded-keys": function ($event) {
                _vm.defaultExpandedKeys = $event
              },
              select: _vm.onSelect,
              check: _vm.onCheck,
            },
          },
          [
            _c("a-icon", {
              staticStyle: { color: "#2fcfeb" },
              attrs: { slot: "dealer", type: "team" },
              slot: "dealer",
            }),
            _c("a-icon", {
              staticStyle: { color: "#52c41a" },
              attrs: { slot: "region", type: "cluster" },
              slot: "region",
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "right_table" },
      [
        _c("x-grid", {
          ref: "grid",
          staticStyle: { height: "83vh", "overflow-y": "auto" },
          attrs: {
            id: "formList",
            rowId: _vm.rowId,
            "pager-config": _vm.pagerConfig,
            "form-config": _vm.formConfig,
            url: _vm.url,
            columns: _vm.columns,
            "checkbox-config": _vm.checkboxConfig,
            "toolbar-config": _vm.toolbarConfig,
            "print-config": _vm.printConfig,
            "export-config": _vm.exportConfig,
            "other-params": _vm.otherParams,
            cellClick: _vm.chooseRow,
            cellDbClick: _vm.updateRow,
          },
          on: {
            "toolbar-addData": _vm.addRow,
            "toolbar-delData": function ($event) {
              return _vm.delRow("删除后，已添加到客户信息的标签也一起删除")
            },
          },
        }),
        _c(
          "a-modal",
          {
            attrs: {
              title: "标签详情",
              centered: "",
              closable: false,
              footer: null,
              maskClosable: false,
              visible: _vm.editModalVisible,
              width: 500,
            },
          },
          [
            _vm.editModalVisible
              ? _c("detailForm", {
                  ref: "form",
                  attrs: { rowId: _vm.editRowId, selectedObj: _vm.selectedObj },
                  on: {
                    cancelled: function ($event) {
                      return _vm.closeEdit()
                    },
                    saved: function ($event) {
                      return _vm.closeEdit(true)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "a-modal",
          {
            attrs: {
              title: "标签分组详情",
              centered: "",
              closable: false,
              footer: null,
              maskClosable: false,
              visible: _vm.labelGroupVisible,
              width: 500,
            },
          },
          [
            _vm.labelGroupVisible
              ? _c("detailGroupForm", {
                  ref: "form",
                  attrs: {
                    parentId: _vm.parentId,
                    groupId: _vm.groupId,
                    tagTypeName: _vm.tagTypeName,
                    readyTodo: _vm.readyTodo,
                    selectedObj: _vm.selectedObj,
                  },
                  on: {
                    cancelled: _vm.closeLabelGroup,
                    reload: _vm.getTagList,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }